module.exports = __webpack_public_path__ + "img/pptx.7b258a1e.svg";